export default __webpack_public_path__ + "static/media/nn.dca8b20b.svg";